<template>
  <div>
    <HMModalHeader
      :title="$t('CUSTOMERS.LINK.PAUSE_SUBSCRIPTION')"
      @close="$emit('close')"
    />
    <form @submit.prevent="pauseOrder">
      <div v-html="$t('CUSTOMERS.TEXT.PAUSE_SUBSCRIPTION_DESCRIPTION')"></div>
      <HMModalFooter
        class="mt-3"
        :discardButton="$t('GENERAL.BUTTON.GO_BACK')"
        :submitButton="$t('CUSTOMERS.LINK.PAUSE_SUBSCRIPTION')"
        :loading="isLoading"
        :disabled="isLoading"
        @close="$emit('close')"
      />
    </form>
  </div>
</template>

<script>
import Vue from 'vue';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  name: 'PauseCustomerOrderModal',
  props: {
    orderId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    async pauseOrder() {
      this.isLoading = true;
      try {
        await this.$store.dispatch('sale/pauseOrder', {
          id: this.orderId,
        });
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('CUSTOMERS.NOTIFICATIONS.PAUSE_ORDER_SUCCESS'),
        });
        this.$emit('close');
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('CUSTOMERS.NOTIFICATIONS.PAUSE_ORDER_ERROR'),
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
});
</script>

<style lang="scss" scoped></style>
